/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Not found
 * @export
 * @interface PostFleetsFleetIdWingsNotFound
 */
export interface PostFleetsFleetIdWingsNotFound {
    /**
     * Not found message
     * @type {string}
     * @memberof PostFleetsFleetIdWingsNotFound
     */
    error?: string;
}

/**
 * Check if a given object implements the PostFleetsFleetIdWingsNotFound interface.
 */
export function instanceOfPostFleetsFleetIdWingsNotFound(value: object): value is PostFleetsFleetIdWingsNotFound {
    return true;
}

export function PostFleetsFleetIdWingsNotFoundFromJSON(json: any): PostFleetsFleetIdWingsNotFound {
    return PostFleetsFleetIdWingsNotFoundFromJSONTyped(json, false);
}

export function PostFleetsFleetIdWingsNotFoundFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostFleetsFleetIdWingsNotFound {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function PostFleetsFleetIdWingsNotFoundToJSON(json: any): PostFleetsFleetIdWingsNotFound {
    return PostFleetsFleetIdWingsNotFoundToJSONTyped(json, false);
}

export function PostFleetsFleetIdWingsNotFoundToJSONTyped(value?: PostFleetsFleetIdWingsNotFound | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

